import React from 'react';
import PropTypes from 'prop-types';
import { FLIGHT_TYPES } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import HintButton from 'src/components/HintButton';
import { Airplane } from '@lt/components/icons-react/userflow';
import { FlightTypePropTypes } from '../../proptypes/flights';

const baseCls = 'checkout-flight-type';

const FlightType = ({
  type,
  showFlightClass,
  showIcon,
  showDescription,
  showPluralTitle,
  showTooltip,
  className,
}) => {
  const { flightType, flightClass } = type;

  const { title, pluralTitle, tooltipDescription, tooltipTitle } =
    FLIGHT_TYPES[flightType];

  return (
    <div className={`${baseCls} ${className}`}>
      {showIcon && <Airplane />}

      <div>
        {showPluralTitle ? pluralTitle : title}

        {showFlightClass ? `, ${flightClass}` : '.'}

        <div className={`${baseCls}__description`}>
          {showDescription && tooltipDescription && tooltipDescription}

          {showTooltip && tooltipTitle && <HintButton text={tooltipTitle} />}
        </div>
      </div>
    </div>
  );
};

FlightType.propTypes = {
  type: FlightTypePropTypes.isRequired,
  showIcon: PropTypes.bool,
  showDescription: PropTypes.bool,
  showFlightClass: PropTypes.bool,
  showPluralTitle: PropTypes.bool,
  showTooltip: PropTypes.bool,
  className: PropTypes.string,
};

FlightType.defaultProps = {
  showIcon: true,
  showTooltip: true,
  showDescription: true,
  showFlightClass: false,
  showPluralTitle: false,
  className: '',
};

export default FlightType;
